<template>
  <svg
    class="km-icon-component"
    :width="width"
    :height="height"
    :style="{ color: colorStyle }"
    v-on="$listeners"
  />
</template>

<script>
function fetchIcon(name) {
  if (!name.startsWith('km-icon-')) throw new Error('Icon names should start with km-icon-')
  if (!fetchIcon.cache.has(name)) {
    fetchIcon.cache.set(
      name,
      import(
        /* webpackMode: "lazy-once" */
        /* webpackChunkName: "icons" */
        `@/icons/${name.slice(8)}.svg`
      ).then(rawIcon => {
        const dom = new DOMParser().parseFromString(rawIcon.default, 'image/svg+xml')
        replaceColorAttribute(dom, 'fill', 'currentColor')
        replaceColorAttribute(dom, 'stroke', 'currentColor')
        return dom
      }),
    )
  }
  return fetchIcon.cache.get(name)
}
fetchIcon.cache = new Map()

function replaceColorAttribute(dom, attribute, color) {
  for (const el of dom.querySelectorAll(`[${attribute}]`)) {
    if (el.getAttribute(attribute) !== 'none') {
      el.setAttribute(attribute, color)
    }
  }
}

export default {
  name: 'KmIcon',

  props: {
    name: {
      required: true,
      validator(name) {
        return typeof name === 'string' && name.startsWith('km-icon-')
      },
    },
    size: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
    },
  },

  computed: {
    width() {
      return this.size
    },
    height() {
      return this.size
    },
    colorStyle() {
      if (!this.color) return
      return this.$vuetify.theme[this.color]
    },
  },

  watch: {
    name() {
      this.renderIcon()
    },
  },

  mounted() {
    this.renderIcon()
  },

  methods: {
    async renderIcon() {
      const dom = await fetchIcon(this.name)
      this.$el.setAttribute('viewBox', dom.documentElement.getAttribute('viewBox'))
      while (this.$el.firstChild) {
        this.$el.removeChild(this.$el.firstChild)
      }
      for (const node of dom.documentElement.childNodes) {
        this.$el.appendChild(node.cloneNode(true))
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.km-icon-component {
  vertical-align: middle;
}
</style>
